/**
 * Production Page
 *
 * Staff workflow page for managing orders in production stages.
 */

import WorkflowPage from './WorkflowPage';
import type { WorkflowStage } from '../types';

const PRODUCTION_STAGES: WorkflowStage[] = [
  'APPROVED',
  'IN_PRODUCTION',
  'IN_QA',
];

export default function Production() {
  return (
    <WorkflowPage
      title="Production"
      stages={PRODUCTION_STAGES}
      defaultStage="IN_PRODUCTION"
      tabLabels={{ APPROVED: 'Prep' }}
      filter="exclude_unpaid_drafts"
      emptyMessage="No orders currently in production"
      primaryAction={{
        content: 'Production Prep',
        url: '/prep',
      }}
    />
  );
}
